var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1CC89F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 8 20 8ZM15.9417 16.6637C15.756 16.1436 15.1838 15.8725 14.6637 16.0583C14.1436 16.244 13.8725 16.8163 14.0583 17.3364L14.6524 19H14C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21H15C15.1212 21 15.2374 20.9785 15.3449 20.939L16.5583 24.3364C16.6972 24.7254 17.0611 24.989 17.4741 24.9997C17.8871 25.0104 18.2642 24.766 18.4231 24.3846L20 20.6L21.5769 24.3846C21.7358 24.766 22.1129 25.0104 22.5259 24.9997C22.9389 24.989 23.3028 24.7254 23.4417 24.3364L24.6551 20.939C24.7626 20.9785 24.8788 21 25 21H26C26.5523 21 27 20.5523 27 20C27 19.4477 26.5523 19 26 19H25.3476L25.9417 17.3364C26.1275 16.8163 25.8564 16.244 25.3363 16.0583C24.8162 15.8725 24.244 16.1436 24.0583 16.6637L22.4282 21.2278L20.9231 17.6154C20.7678 17.2428 20.4037 17 20 17C19.5963 17 19.2322 17.2428 19.0769 17.6154L17.5718 21.2278L15.9417 16.6637Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.d304b52936c908addcf50c7d4f54da30.svg";
export { ForwardRef as ReactComponent };